export default __webpack_public_path__ + "static/media/Jalsa1.13012fc0.mp3";